<template>
  <div class="details">
    <div class="details_header">
      <span @click="goBack()">
        <img src="../../static/images/back.png">
      </span>
      <h2>下单状态</h2>
      <span></span>
    </div>

    <div class="details_content">
      <div class="details_content_steps">
        <el-steps :active="statusNum">
          <el-step title="已下单" icon="el-icon-document-checked"></el-step>
          <el-step title="已接单" icon="el-icon-dish" v-if="!isExpired"></el-step>
          <el-step title="已过期" icon="el-icon-warning" v-else></el-step>
          <el-step title="已打印" icon="el-icon-printer" v-if="!isExpired"></el-step>
        </el-steps>
      </div>
      <h6 class="details_content_steps_note" v-if="!isExpired">店家小二已飞奔而来，请您稍等...</h6>
      <h6 class="details_content_steps_note" v-else>如有疑问，请联系店家小二...</h6>
      <h5 class="details_content_shopName">{{shopName}}</h5>
    </div>
  </div>
</template>

<script>
  import {
    interfaceFn
  } from '@/assets/util.js';
  export default {
    data() {
      return {
        msg: 'details',
        statusNum: 1,
        shopName: '',
        back: false,
        websock: null,
        isExpired: false,
      }
    },
    created() {},
    mounted() {
      this.init();
    },
    updated() {},

    methods: {
      init() {
        this.shopName = window.localStorage.getItem('shopName');
        this.initWebSocket();
      },

      goBack() {
        this.back = true;
        if (this.$store.state.isScan) {
          this.$router.push({
            path: '/room'
          });
        } else {
          this.$router.push({
            path: '/'
          });
        }
        this.websocketclose();
      },

      //初始化websocket
      initWebSocket() {
        if (this.back) return;
        if (window.location.hostname == 'localhost') return;
        const wsuri = "ws://weixin.ypos.vip/repastServer/" + window.localStorage.getItem('externalId');
        this.websock = new WebSocket(wsuri);
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
        //console.log('初始化');
      },
      // 连接建立之后执行send方法发送数据
      websocketonopen() {
        let actions = this.printInfo; // 传输的数据
        this.websocketsend(JSON.stringify({"toUserId": window.localStorage.getItem('externalId')}));
        //console.log('传输的数据');
      },
      //连接建立失败重连
      websocketonerror() {
        this.initWebSocket();
        //console.log('连接建立失败重连');
      },
      //数据接收
      websocketonmessage(e) {
        // console.log(e);
        if (e.data != 'success' && e.data != 'error' && e.data != 'null' && e.data != 'undefined' && e.data != '') { // 0成功，1失败，2过期
          let data = JSON.parse(e.data);
          // console.log(data);
          if (data.printStatus == 0) {
            this.statusNum = 3;
          } else if (data.pcStatus == 0) {
            this.statusNum = 2;
          } else if (data.serverStatus == 0) {
            this.statusNum = 1;
          } else if (data.printStatus == 2 || data.pcStatus == 2 || data.serverStatus == 2) {
            this.statusNum = 2;
            this.isExpired = true;
          } else {
            this.statusNum = 0;
          }
        }
      },
      //数据发送
      websocketsend(Data) {
        this.websock.send(Data);
        //console.log('数据发送');
      },
      //关闭
      websocketclose(e) {
        //console.log('断开连接', e);
      },
    }
  }
</script>

<style scoped>
  @import url("../../static/css/details.css");
</style>



// WEBPACK FOOTER //
// src/components/Details.vue